<form *ngIf="!nuevo" class="example-form" [formGroup]='usersForm'>

  <div class="row">
    <div class="col-md-12">
      <mat-form-field class="example-full-width">
        <input matInput placeholder="Choose a part" [matAutocomplete]="auto" formControlName='userInput'>
      </mat-form-field>
      <!-- <span>Your choice is: {{usersForm.get('userInput').value | json}}</span> -->
    
      <mat-autocomplete (optionSelected)="OnHumanSelected($event.option)" #auto="matAutocomplete" [displayWith]="displayFn">
        <mat-option *ngIf="loading" class="is-loading"><mat-spinner diameter="50"></mat-spinner></mat-option>
        <mat-option *ngIf="!loading" [value]="nuevoScrap">
          <strong style="font-size: 20px;">
            <i style="color: #28B463;" class="fa fa-plus-circle" aria-hidden="true"></i>
            &nbsp; {{nuevoScrap.name}}
          </strong>
        </mat-option>
        <ng-container *ngIf="!loading">
          <mat-option *ngFor="let option of options | async" [value]="option">
            <span>{{ option.name }}</span>
          </mat-option>
        </ng-container>
      </mat-autocomplete>
    </div>
  </div>

</form>